<template>
  <div class="about">
    <div class="page-header">
      <h1>About</h1>
    </div>
    <section class="page-content">
      <div v-for="c in card_info" :key="c.id" class="card">
        <h3 class="title">{{ c.title }}</h3>
        <p>{{ c.body }}</p>
      </div>
    </section>
  </div>
</template>

<style scoped>
section.page-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
/* card styles */
.page-content .card {
  grid-column: span 1;
  border-radius: 1rem;
  box-shadow: 2px 8px 30px lightgrey;
  padding: 1rem;
}
/* media queries */
@media only screen and (max-width: 998px) {
  .page-content .card {
    grid-column: span 2;
  }
}
</style>

<script>
export default {
  name: "about",
  data() {
    return {
      card_info: [
        {
          title: "Our Mission",
          body:
            "Our vision is to connect entrepreneurs with all the resources they need to succeed in the most SME Business Branding innovative and professional means."
        },
        {
          title: "Our Vision",
          body:
            "To actualise that vision we are on a mission to continually improve in making our services VIRAL to all our esteemed clients. (V)aluable (I)nnovative (R)eliable (A)ccesible (L)eading"
        }
      ]
    };
  }
};
</script>
